module.exports = __webpack_public_path__ + "img/bg-header.a400d4d4.png";